<script>
export default {
  inheritAttrs: false,

  props: {
    icon: {
      type: [Object, Function],
      required: true,
    },

    vertical: {
      type: Boolean,
      default: false,
    },

    primary: {
      type: Boolean,
      default: false,
    },
  },
}
</script>

<template>
  <BaseButton
    v-bind="$attrs"
    class="text-red-500 text-lg flex-1 h-full hover:bg-yellow-300 dark-hover:bg-gray-800
    md:h-72p md:border md:rounded-lg md:w-full md:px-6 md:flex-none md:mb-8"
    :class="{
      'md:bg-red-500 md:border-transparent md:hover:bg-red-400 md:text-white': primary,
      'md:bg-white md:border-red-300 md:hover:bg-yellow-200 md:dark:bg-transparent md:dark:border-red-800': !primary,
    }"
    v-on="$listeners"
  >
    <div
      class="flex items-center justify-center w-full h-full md:justify-start"
      :class="{
        'flex-col md:flex-row': vertical,
      }"
    >
      <component
        :is="icon"
        :class="[
          vertical ? 'mb-1 md:mb-0 md:mr-4': 'mr-4'
        ]"
      />

      <slot />
    </div>
  </BaseButton>
</template>
